import React, {useRef, useEffect, useState} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {Box, Button, Typography, makeStyles} from '@material-ui/core';
import { connect } from "react-redux";
import { nameChange } from "../../coresim/reducers/decisions";
import { bindActionCreators } from "redux";
import {Balloon, Clock} from 'mdi-material-ui';
import changeName from "../../config/changeName"
import Field from '../../admin/Forms/Field';
import graphNumberFormat from '../../helpers/graphNumberFormat';

const useStyles = makeStyles((theme) => ({
  infoTip: {
    margin: theme.spacing(0, .5),
    padding: theme.spacing(.2, .6),
    borderRadius: 5,
    color: 'white',
    cursor: 'help',
  },
  positiveTip: {
    backgroundColor: 'green',
  },
  negativeTip: {
    backgroundColor: 'red',
  },
  valueLabel: {
    fontWeight: 600,
    marginRight: theme.spacing(.5),
  },
  loanBox: {
    '&:hover': {
      backgroundColor: 'rgba(250, 0, 250, 0.08)',
    },
  },
  boxRow: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      width: '95%',
      justifyContent: 'space-around',
    }
  },
  confirmButton: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1)
    },
  }
}));

const Option = ({ loan, onSelect }) => {
  const classes = useStyles();
  const Icon = loan.icon === 'Balloon' ? Balloon : Clock;
  const optClasses = classnames(classes.loanBox, classes.boxRow)
  return (
    <Box
      p={1}
      display="flex"
      alignItems="center"
      flexDirection="column"
      border="1px solid #ccc"
      borderRadius={5}
      style={{ marginBottom: 10 }}

      className={optClasses}
      onClick={onSelect}
    >
      <Icon />

      <Typography component="header" variant="h6">
        {loan.type}
      </Typography>

      <Button color="secondary">
        More Info
      </Button>
    </Box>
  );
};

Option.propTypes = {
  loan: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired
};

const OptionDetails = ({
  confirmed,
  loan,
  onCancel,
  onSave,
  value,
  cash,
  nameChange,
  handleUpdate
}) => {
  const classes = useStyles();
  const Icon = loan.icon === 'Balloon' ? Balloon : Clock;
  const hasError = Boolean(value && Number(value) > cash);
  const [newName, setNewName] = useState();

  const handleNameChange = (event) => {
    setNewName(event.target.value)
  }
  return (
    <Box maxWidth={400} mt={2} display="flex" flexDirection="column">
      <Box display="flex" flexDirection="row">
        <Icon />
        <Typography component="header" variant="h6">
          {loan.type}
        </Typography>
      </Box>
      <Typography variant="body1">
        {loan.description}
      </Typography>

      {confirmed ?
        <Typography variant="body1"><br/>
          New Business Name: {value}
        </Typography>
        :
        <Field
          id='modName'
          name='nameMod'
          label='New Name'
          value={newName}
          onChange={handleNameChange}
          disabled={confirmed}
        />
      }

      <Box
        pt={2}
        display="flex"
        flexDirection={{xs: "column-reverse", md: "row"}}
        justifyContent="space-evenly"
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            nameChange(0);
            onCancel && onCancel()
          }}
        >
          Cancel
        </Button>
        {!confirmed &&
          <Button
            className={classes.confirmButton}
            variant="contained"
            color="primary"
            disabled={hasError}
            onClick={() => {
              nameChange(10000)
              handleUpdate({name: 'businessAs', value: newName});
              onSave && onSave() }}
          >
            {`Change Business Name ${graphNumberFormat(changeName[0].price, 0)}`}
          </Button>
        }
      </Box>

    </Box>
  );
};


OptionDetails.propTypes = {
  confirmed: PropTypes.bool.isRequired,
  loan: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  inputRef: PropTypes.object.isRequired,
  cash: PropTypes.number,
  nameChange: PropTypes.func.isRequired,
};

const MakeOptionDecision = ({
  coresim,
  decisions,
  teamIndex,
  handleUpdate,
  handleChange,
  nameChange,
}) => {
  const vitalsHistory = coresim.teams[teamIndex].vitalsHistory;
  const cash = vitalsHistory[vitalsHistory.length - 1].cash;
  const ref = useRef();
  const classes = useStyles();

  useEffect(() => {
    let aborted = false;
    if (ref.current && Number.isFinite(decisions.nameChangeIndex) && !aborted) {
      ref.current.focus();
    }
    return () => aborted = true;
  }, [ref.current, decisions.nameChangeIndex]);

  return (
    !Number.isFinite(decisions.nameChangeIndex) ?
      <Box className={classes.loanRow} display="flex" mt={2} flexWrap='wrap' flexDirection="row" justifyContent="end">
        {
          changeName.map((loan, i) =>
            <Option
              loan={loan}
              key={i}
              onSelect={() => handleUpdate({name: 'nameChangeIndex', value: i})}
            />)
        }
      </Box> :
      <OptionDetails
        loan={changeName[0]}
        onCancel={() => {
          handleUpdate({name: 'nameChangeConfirmed', value: false});
          handleUpdate({name: 'nameChangeIndex', value: ''});
          handleUpdate({name: 'nameChange', value: ''});
          handleUpdate({name: 'businessAs', value: ''});
        }}
        handleChange={handleChange}
        onSave={() => handleUpdate({ name: 'nameChangeConfirmed', value: true })}
        value={decisions.businessAs}
        confirmed={decisions.nameChangeConfirmed}
        handleUpdate={handleUpdate}
        inputRef={ref}
        cash={cash}
        nameChange={nameChange}

      />

  );
};

const mapStateToProps = (state) => {
  return {
    decisions: state.decisions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      nameChange: (units) => nameChange(units),
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MakeOptionDecision);

MakeOptionDecision.propTypes = {
  coresim: PropTypes.object.isRequired,
  decisions: PropTypes.object.isRequired,
  teamIndex: PropTypes.number.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  nameChange: PropTypes.func.isRequired
};
